import React from "react";
import BaseSectionItem from "./BaseSectionItem";
import { menuData, profileData } from "../const/profileConstants";
import TagListView from "./TagListView";

function CourseItem() {
  return (
    <BaseSectionItem header={menuData[5].value}>
      <TagListView list={profileData.courses} />
    </BaseSectionItem>
  );
}

export default CourseItem;
